import React, { useEffect } from 'react';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { useLazyNcziListExtensionItemsQuery } from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import DynamicSelect from '../../../../Components/Base/DynamicSelect/DynamicSelect';
import { NCZIExtension, NCZIReference } from '../../Interfaces/ncziTypes';
import * as yup from 'yup';
import { NCZIExtensionSelectError } from './NCZIExtensionSearchSelectField';
import { FieldError } from 'react-hook-form';

export interface NCZIExtensionSelectItem {
	label: string;
	value: NCZIExtension;
}

export const NCZIExtensionValidator = (name: string) =>
	yup.object({
		label: yup.string(),
		value: yup.object({
			code: yup.string().required(name),
			scheme: yup.object({
				oid: yup.string(),
			}),
		}),
	});

interface Props {
	oid: string;
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	showCode?: boolean;
	onlyVaccination?: boolean;
	showAdditionalName?: boolean;
}

const NCZIExtensionSearchSelect = React.forwardRef<
	any,
	React.PropsWithChildren<Props>
>((props, ref) => {
	const {
		value,
		onChange,
		showCode = false,
		onlyVaccination = false,
		showAdditionalName = false,
	} = props;
	const [getListExtensionItems] = useLazyNcziListExtensionItemsQuery();

	useEffectAsync(async () => {
		if (value) onChange?.(value);
	});

	const handleSearchItem = async (
		searchInput: string,
	): Promise<SelectValue[]> => {
		const { items: listExtensionItems } = await getListExtensionItems({
			oid: props.oid,
			fulltext: searchInput,
			vaccination: onlyVaccination,
		}).unwrap();

		const items: SelectValue[] = [];

		for (const extensionItem of listExtensionItems?.data || []) {
			if (extensionItem && extensionItem.code) {
				const addName = extensionItem.params?.additionalName;
				items.push({
					label:
						(showCode ? extensionItem.code + ' - ' : '') +
						(extensionItem.name || '') +
						(showAdditionalName && addName ? ' - ' + addName : ''),
					value: {
						code: extensionItem.code,
						scheme: {
							oid: extensionItem.extension?.oid || '',
						},
					},
				});
			}
		}

		return items;
	};

	return <DynamicSelect searchItems={handleSearchItem} {...props} />;
});

export default NCZIExtensionSearchSelect;
